import React from 'react'
import { Container, Row, Col} from "react-bootstrap";
import CountUp from "react-countup";
import {
  FaCode,
  FaMobileAlt,
  FaPaintBrush,
  FaBullhorn,
  FaSearch,
  FaCloud,
} from "react-icons/fa";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
const cardData = [
  {
    id: 1,
    title: "Intelistock",
    description:
      "AI-based inventory management with real-time traceability, GRN tracking, and predictive restocking.",
    icon: <FaCode size={40} color="#4CAF50" />,
  },
  {
    id: 2,
    title: "inteliDoc",
    description:
      "Secure online drawing & document management system with versioning, approvals, and audit trails.",
    icon: <FaMobileAlt size={40} color="#FF9800" />,
  },
  {
    id: 3,
    title: "InteliPass",
    description:
      "Smart visitor & employee access control with facial recognition, QR validation, and gate integration.",
    icon: <FaPaintBrush size={40} color="#00B894" />,
  },
  {
    id: 4,
    title: "InteliQMS",
    description:
      "Digital quality management for defense & aerospace QA workflows, ATP/NCR tracking, and compliance.",
    icon: <FaBullhorn size={40} color="#E74C3C" />,
  },
  {
    id: 5,
    title: "InteliTrack",
    description:
      "Real-time asset & logistics tracking using RFID, GPS, and IoT with geo-fencing and analytics.",
    icon: <FaSearch size={40} color="#3498DB" />,
  },
  {
    id: 6,
    title: "InteliShuttle",
    description:
      "GPS & facial-recognition shuttle tracking with stop-wise attendance for industrial campuses.",
    icon: <FaCloud size={40} color="#343A40" />,
  },
];
const IconCarousel = () => {
  return (
    <div style={{ padding: "2rem", width: "100%" }}>
      <Swiper
        modules={[Autoplay]}
        loop={true}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        breakpoints={{
          0: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
        spaceBetween={20}
      >
        {cardData.map((card) => (
          <SwiperSlide key={card.id}>
            <div className="card carousel-card">
              <span className="text-center"> {card.icon}</span>

              <h5>{card.title}</h5>
              <p>{card.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
const Service = () => {
  return (
    <>
      <section className="stats-section section" id="services">
        <Container>
          <Row className="gy-4 text-center justify-content-center">
            {[
              { value: 6, label: "Enterprise Products", suffix: "" },
              { value: 8, label: "Industries Served", suffix: "+" },
              { value: 24, label: "Support", suffix: "/7" },
              { value: 100, label: "On-Prem / Secure", suffix: "%" },
            ].map((stat, idx) => (
              <Col
                key={idx}
                xs={6}
                md={3}
                data-aos="fade-up"
                data-aos-delay={idx * 150}
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                <div className="stat-block">
                  <h3 className="stat-value">
                    <CountUp
                      end={stat.value}
                      duration={2}
                      suffix={stat.suffix}
                    />
                  </h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Services Section */}
      {/* <section className="mt-4 py-5">
        <Container>
          <h2 className="text-center fw-bold text-dark m-0">Our Services</h2>
          <p className="text-center fw-medium text-dark small">
            Comprehensive web development solutions for your business
          </p>
          <Row className="mt-4">
            {[
              "Web Apps",
              "UI/UX Design",
              "Cloud Hosting",
              "Security & Testing",
            ].map((service, idx) => (
              <Col md={3} className="mb-4" key={idx}>
                <div className="card h-100 service-card rounded-4">
                  <Card.Body>
                    <span className="btn btn-light rounded-3 shadow-sm mb-3">
                      <FaCheckCircle className="text-orange fs-3" />
                    </span>

                    <h5>{service}</h5>
                    <p className="text-muted small">
                      Custom-built solutions tailored to your business needs.
                    </p>
                  </Card.Body>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section> */}
      <section className="section">
        <Container>
          <h2
            className="text-center fw-bold text-dark m-0"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            Our Solutions
          </h2>

          <p
            className="text-center fw-medium text-dark small"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-duration="800"
          >
            Enterprise software products for industry, defense, and public sector.
          </p>

          <div className="mt-1" data-aos="fade-up" data-aos-delay="200">
            <IconCarousel />
          </div>
        </Container>
      </section>
      </>
  )
}

export default Service
